import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import "../../styles/app/PromoSection.css";

const PromoSection: React.FC = () => {
  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState({
    hours: 48,
    minutes: 0,
    seconds: 0,
  });
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    let storedEndTime = localStorage.getItem("promoEndTime");

    if (storedEndTime === "expired") {
      setExpired(true);
      return;
    }

    let endTime: number;

    if (storedEndTime) {
      endTime = parseInt(storedEndTime, 10);
    } else {
      endTime = new Date().getTime() + 48 * 60 * 60 * 1000;
      localStorage.setItem("promoEndTime", endTime.toString());
    }

    let interval: NodeJS.Timeout;

    const updateTimer = () => {
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance <= 0) {
        clearInterval(interval);
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
        localStorage.setItem("promoEndTime", "expired");
        setExpired(true);
      } else {
        const hours = Math.floor(distance / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        setTimeLeft({ hours, minutes, seconds });
      }
    };

    updateTimer(); // inicializa
    interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, []);

  const pad = (num: number) => String(num).padStart(2, "0");

  if (
    expired ||
    (timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0)
  ) {
    return null;
  }

  return (
    <section className="promo-section">
      <div className="promo-banner">
        <div className="promo-text">
          {t("promoSection.bannerText")}
        </div>
        <div className="promo-timer">
          <div className="promo-timer-block">
            <span className="promo-time">{pad(timeLeft.hours)}</span>
            <span className="promo-label">{t("promoSection.hours")}</span>
          </div>
          <div className="promo-timer-block">
            <span className="promo-time">{pad(timeLeft.minutes)}</span>
            <span className="promo-label">{t("promoSection.minutes")}</span>
          </div>
          <div className="promo-timer-block">
            <span className="promo-time">{pad(timeLeft.seconds)}</span>
            <span className="promo-label">{t("promoSection.seconds")}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromoSection;
